const ipetBookingObj = {
    STYLE: 'ipetbooking',
    ALIAS_LABEL: '{name}網址',
    COMPLETE_ADD_CONFIRM_MESSAGE: '你已完成{name}新增，是否上架讓客戶購買呢？',
    DELETE_CONFIRM_MESSAGE: '確認刪除此{name}？',
    DESCRIPTION_LABEL: '{name}描述',
    OVERLAP_LABEL: '同一時段是否只可進行一項{name}？',
    LEAVE_ADD_CONFIRM_MESSAGE: '尚未完成新增，請問是否確定離開新增{name}？',
    LEAVE_EDIT_CONFIRM_MESSAGE: '確認是否放棄編輯{name}？',
    NAME_LABEL: '{name}名稱',
    STATE_LABEL: '{name}開放購買',
    STATE_OFF_CONFIRM_MESSAGE: '關閉分店後，此分店將無法接受預約',
    STATE_ON_CONFIRM_MESSAGE: '上架後客戶將能從網站預約此分店，請確認是否開啟分店？',
    TITLE_STATE_AND_DISPLAY: '{name}開放與顯示',
    CHECKOUT_NOTE_LABEL: '{name}自訂備註標題（若無填寫則顯示預設標題：{default}）',
    APP_NAME: 'ipetBooking',
    APP_SUBNAME: '愛寵訂',
    activity: {
      NAME: '活動',
      STEP_INVENTORY_INTRO: '想要在什麼時候讓客戶參與活動呢？可以設定多重時段與重複週期喔！暫不編輯時段，請按離開，完成時段編輯請按下一步。',
      CHECKOUT_NOTE_LABEL_DEFAULT: '其他備註',
    },
    course: {
      NAME: '課程',
      STEP_INVENTORY_INTRO: '想要在什麼時候開課呢？可以設定多重時段與重複週期喔！暫不編輯時段，請按離開，完成時段編輯請按下一步。',
      CHECKOUT_NOTE_LABEL_DEFAULT: '其他備註',
    },
    service: {
      NAME: '分店',
      STEP_INVENTORY_INTRO: '想要在什麼時候讓貴賓預約服務項目呢？可以設定多重時段與重複週期喔！暫不編輯時段，請按離開，完成時段編輯請按下一步。',
      CHECKOUT_NOTE_LABEL_DEFAULT: '過去病史',
      SPA: 'SPA'
    },
    reservation: {
      NAME: '訂位項目',
      STEP_INVENTORY_INTRO: '想要在什麼時候讓客戶訂位呢？可以設定多重時段與重複週期喔！暫不編輯時段，請按離開，完成時段編輯請按下一步。',
      CHECKOUT_NOTE_LABEL_DEFAULT: '用餐目的與其他備註',
    },
    guide: {
      NAME: '導覽',
      STEP_INVENTORY_INTRO: '想要在什麼時候讓開放報名呢呢？可以設定多重時段與重複週期喔！暫不編輯時段，請按離開，完成時段編輯請按下一步。',
      CHECKOUT_NOTE_LABEL_DEFAULT: '參觀目的',
    },
    success: {
      ORDER_QRCODE_ADMIN_VERIFY_SUCCESS: '憑證使用成功',
    },
    global: {
      HEADER_ADD_PREFIX: '新增{name}',
      HEADER_EDIT_PREFIX: '編輯{name}：{item}',
    },
    orderManage: {
      USER_AND_PET: '使用人與寵物',
      PRICE_ORDER: '訂單'
    },
    prepaid: {
      BASE: '包月',
      EDIT_PRICE: "包月價格編輯",
      DEDUCTION_TITLE: '包月抵扣',
      CLIENT_CATEGORY: '類別'
    },
    member: {
      KIND_TO_CATEGORY: '種類',
      BODY_TO_TYPE: '體型',
      PET_TO_SKIN: '寵物',
      PET_TO_SURNAME: '寵物'
    },
    reserve: {
      CLIENT: '寵物',
      PET_TO_EMPTY: '寵物',
      SIZE_CATEGORY: '體型',
      PET_SIZE:'體型',
      SIZE_TO_CLIENT: '體型',
      NAME_TO_EMPTY: '名'
    },
    afterServiceQ: {
      Q1: '璧蝨',
      Q2: '耳炎',
      Q3: '耳疥',
      situation1: '少量',
      situation2: '多量'
    },
    sex: {
      Male: '公',
      Female: '母',
    },
    setting: {
      PRODUCT_NAME: '小捲尾寵物美容'
    },
    
  }

  export { ipetBookingObj }